'use strict';

module.exports = getQuery;

function getQuery(param) {
  if (typeof window === 'undefined') {
    return;
  }
  var net = require('@ali/network');
  return net.query(param) || net.query(param, decodeURIComponent(window.location.href));
}